module.exports = __webpack_public_path__ + "img/file-icon.56c69e1f.svg";